module.exports = __webpack_public_path__ + "static/media/iconBB.19ce2d35.svg";